import Envs from '@agoras/envs';
import { MSHeaders, FALLBACK_LANGUAGE, CATALOG_SUPPORTED_LANGUAGES } from '../httpClient/constants.esm.js';
import Source from './Source.esm.js';

function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var SEARCH_QUERY_PARAMS = {
    search: 'searchQuery',
    gallery: 'gallery',
    version: 'api-version',
    market: 'market',
    language: 'language',
    select: 'select',
    industryCloud: 'industryCloud',
    productTypes: 'productTypes',
    suggestionTypes: 'suggestionTypes'
};
var APPSOURCE_SEARCH_API_KEY = // [SuppressMessage("Microsoft.Security", "CS002:SecretInNextLine", Justification="Not a credential")]
'56f7729c7a94fb9e607ac4d939725c4e9169a4a8c6b9f3a265224b7a0adf44da';
var APPS_GALLERY = 'AppsourceApps';
var CONSULTING_SERVICES_GALLERY = 'AppsourceConsultingServices';
var CONSULTING_SERVICES = 'ConsultingServices';
var isWordSearch = function(suggestion) {
    return suggestion.suggestionType === 'WordSearch';
};
var isEntity = function(suggestion) {
    return suggestion.suggestionType === 'Entity';
};
var isExpectedGallery = function(gallery) {
    return gallery === APPS_GALLERY || gallery === CONSULTING_SERVICES_GALLERY;
};
var _obj;
var ProductTypesByGallery = (_obj = {}, _define_property(_obj, APPS_GALLERY, ''), _define_property(_obj, CONSULTING_SERVICES_GALLERY, CONSULTING_SERVICES), _obj);
var SearchAPI = /*#__PURE__*/ function(Source) {
    _inherits(SearchAPI, Source);
    var _super = _create_super(SearchAPI);
    function SearchAPI(httpClient) {
        _class_call_check(this, SearchAPI);
        return _super.call(this, {
            httpClient: httpClient,
            baseUrl: Envs.getConfig().searchApi
        });
    }
    _create_class(SearchAPI, [
        {
            key: "suggestionsURL",
            get: function get() {
                var url = new URL("".concat(this._baseUrl, "/suggestions/products"));
                url.searchParams.append(SEARCH_QUERY_PARAMS.select, 'Id,DisplayText,IconUrl,ProductType,LinkedAddinsTypes');
                url.searchParams.append(SEARCH_QUERY_PARAMS.version, '2023-01-01-preview');
                url.searchParams.append(SEARCH_QUERY_PARAMS.suggestionTypes, 'WordSearch,Entity');
                return url;
            }
        },
        {
            key: "getSuggestions",
            value: function getSuggestions(options) {
                var _this = this;
                return _async_to_generator(function() {
                    var searchTerm, gallery, _options_market, market, _options_language, language, _options_unifiedExperience, unifiedExperience, supportedLanguage, url, headers, _ref, data, responseHeaders, _responseHeaders_MSHeaders_REQUEST_ID, suggestionsRequestId;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                searchTerm = options.searchTerm, gallery = options.gallery, _options_market = options.market, market = _options_market === void 0 ? 'US' : _options_market, _options_language = options.language, language = _options_language === void 0 ? FALLBACK_LANGUAGE : _options_language, _options_unifiedExperience = options.unifiedExperience, unifiedExperience = _options_unifiedExperience === void 0 ? false : _options_unifiedExperience;
                                supportedLanguage = CATALOG_SUPPORTED_LANGUAGES.includes(language.toLowerCase()) ? language : FALLBACK_LANGUAGE;
                                url = _this.suggestionsURL;
                                url.searchParams.append(SEARCH_QUERY_PARAMS.language, supportedLanguage);
                                url.searchParams.append(SEARCH_QUERY_PARAMS.market, market);
                                url.searchParams.append(SEARCH_QUERY_PARAMS.search, searchTerm);
                                if (isExpectedGallery(gallery)) {
                                    if (!unifiedExperience) {
                                        url.searchParams.append(SEARCH_QUERY_PARAMS.gallery, gallery);
                                    }
                                    if (gallery === CONSULTING_SERVICES_GALLERY) {
                                        url.searchParams.append(SEARCH_QUERY_PARAMS.productTypes, ProductTypesByGallery[CONSULTING_SERVICES_GALLERY]);
                                    }
                                } else if (gallery.toLocaleLowerCase().includes('industry')) {
                                    url.searchParams.append(SEARCH_QUERY_PARAMS.industryCloud, 'true');
                                }
                                headers = _define_property({}, MSHeaders.API_KEY, APPSOURCE_SEARCH_API_KEY);
                                return [
                                    4,
                                    _this._httpClient.get(url.toString(), {
                                        headers: headers
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, responseHeaders = _ref.headers;
                                suggestionsRequestId = (_responseHeaders_MSHeaders_REQUEST_ID = responseHeaders[MSHeaders.REQUEST_ID]) !== null && _responseHeaders_MSHeaders_REQUEST_ID !== void 0 ? _responseHeaders_MSHeaders_REQUEST_ID : '';
                                return [
                                    2,
                                    _object_spread_props(_object_spread({}, data), {
                                        suggestionsRequestId: suggestionsRequestId
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SearchAPI;
}(Source);

export { APPS_GALLERY, CONSULTING_SERVICES, CONSULTING_SERVICES_GALLERY, SEARCH_QUERY_PARAMS, SearchAPI, isEntity, isWordSearch };
